import {createFileRoute} from '@tanstack/react-router';
import {LoanAccountCloseSuccessPage} from 'features/loans/pages/LoanAccountClosePage/LoanAccountCloseSuccessPage';

export const Route = createFileRoute(
  '/_protected/accounts/loans/$accountId/close/success',
)({
  component: LoanAccountCloseSuccessPage,
});
